import "core-js/modules/es.object.define-property";
import { __decorate, __extends, __read, __spread } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { pathGet, pathSet } from '@/lib/service/storage';
import { dateNow, dateOffset, dateFormat } from '@/lib/utils';
import { WX_SERVER_ID_VALID_DAY } from '@/lib/constant';
/**
 * 班级头像上传逻辑
 *
 * - @add 数据添加
 * - @remove 数据删除
 */

var AvatarUploader =
/** @class */
function (_super) {
  __extends(AvatarUploader, _super);

  function AvatarUploader() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** 图片内容，存放url或者是localId */


    _this.image = null;
    /** mask是否可见 */

    _this.maskVisible = false;
    return _this;
  }

  Object.defineProperty(AvatarUploader.prototype, "opacity", {
    get: function get() {
      return this.image ? 1 : 0;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 获得元素
   *
   * @return {} uploader
   */

  AvatarUploader.prototype.getImage = function () {
    return this.image;
  };
  /**
   * 设置头像
   *
   * @param {} image 头像内容
   */


  AvatarUploader.prototype.setImage = function (image) {
    var $uploader = this.$refs.uploader;
    $uploader.setImages([{
      url: image,
      image: image,
      serverId: null
    }]);
    this.image = image;
  };
  /**
   * 删除当前的图片信息
   */


  AvatarUploader.prototype.removeImage = function () {
    var $uploader = this.$refs.uploader;
    $uploader.setImages([]);
  };
  /**
   * 数据开始加载
   */


  AvatarUploader.prototype.onLoad = function () {
    this.maskVisible = true;
    this.$emit('load');
  };
  /**
   * 图片加载完成
   */


  AvatarUploader.prototype.onFinish = function () {
    this.maskVisible = false;
    this.$emit('finish');
  };
  /**
   * add事件
   *
   *  {image, serverId}
   */


  AvatarUploader.prototype.onAdd = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    var $uploader = this.$refs.uploader;
    var images = $uploader.getImages();
    this.image = images[0].url;

    if (this.storeKey) {
      pathSet(this.storeKey, {
        key: images[0].key,
        url: images[0].url,
        serverId: images[0].serverId
      }, dateFormat(dateOffset(dateNow(), WX_SERVER_ID_VALID_DAY), 'Y-m-d H:i:s'));
    }

    this.$emit.apply(this, __spread(['add'], args));
  };
  /**
   * remove事件
   *
   *  {} 可能没有数据
   */


  AvatarUploader.prototype.onRemove = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    this.image = null;
    this.$emit.apply(this, __spread(['remove'], args));
    var $uploader = this.$refs.uploader;
    $uploader.request();
  };

  AvatarUploader.prototype.mounted = function () {
    if (this.storeKey) {
      var result = pathGet(this.storeKey);

      if (result) {
        var resultJSON = JSON.parse(result);
        var $uploader = this.$refs.uploader;

        if ($uploader) {
          $uploader.add({
            url: resultJSON.url || resultJSON.image,
            image: resultJSON.url || resultJSON.image,
            serverId: resultJSON.serverId
          });
          this.image = resultJSON.url;
        }
      }
    }
  };

  __decorate([Prop({
    type: String,
    "default": 'wechat'
  })], AvatarUploader.prototype, "mode", void 0);

  __decorate([Prop({
    type: String
  })], AvatarUploader.prototype, "hint", void 0);

  __decorate([Prop({
    type: [Object, Array]
  })], AvatarUploader.prototype, "backgroundStyle", void 0);

  __decorate([Prop({
    type: [Object, Array]
  })], AvatarUploader.prototype, "removeClass", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], AvatarUploader.prototype, "blank", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": true
  })], AvatarUploader.prototype, "canModify", void 0);

  __decorate([Prop({})], AvatarUploader.prototype, "uploaderClass", void 0);

  __decorate([Prop({
    type: String
  })], AvatarUploader.prototype, "storeKey", void 0);

  __decorate([Prop({
    type: String
  })], AvatarUploader.prototype, "accept", void 0);

  AvatarUploader = __decorate([Component({
    name: 'SingleUploader'
  })], AvatarUploader);
  return AvatarUploader;
}(Vue);

export default AvatarUploader;